import React from 'react';
import ReactDOM from 'react-dom/client';

import { CartProvider } from '../../contexts/CartContext';
import ProductPage from './pages/ProductPage';
import type { ProductPageData } from './types';
import './index.css';

function initProductPage() {
    const root = document.getElementById('product-root');
    const pageDataEl = document.getElementById('pageData');
    if (!root || !pageDataEl) { return; }

    const pageData: ProductPageData = JSON.parse(pageDataEl.textContent || '{}');
    const reactRoot = ReactDOM.createRoot(root);
    reactRoot.render(
        React.createElement(
            CartProvider,
            { csrfToken: pageData.csrfToken || undefined },
            React.createElement(ProductPage, pageData),
        ),
    );
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
} else {
    initProductPage();
}

if (module.hot) { module.hot.accept(); }
